import React, { useContext } from "react";
import i18next from "i18next";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Button } from "@mui/material";
import { ModuleContext } from "../utils/Constants";
import { useSelector } from "react-redux";
import { isComponentDisabled, isComponentVisible } from "../utils/SaitUtils";

export default function SaitButtonUpload(props) {
	const { onUpload, ...buttonProps } = props;

	const componentModule = useContext(ModuleContext);
	const objModArray = useSelector((state) => state["auth"]["objMod"]);
	const objMod = objModArray.find((objModObject) => objModObject.moduleName === componentModule && objModObject.idObject === props.objmod);

	const handleFileChange = (event) => {
		const selectedFiles = props.multiple ? event.target.files : event.target.files[0];
		props.onUpload(selectedFiles);
		event.target.value = null;
	};

	var attr = {};
	if (props.multiple) {
		attr["multiple"] = true;
	}
	if (props.accept) {
		attr["accept"] = props.accept;
	}

	return isComponentVisible(objMod, props.hidden) ? (
		<Button
			{...buttonProps}
			variant={props.variant || "contained"}
			component="label"
			endIcon={props.endIcon || <CloudUploadIcon />}
			disabled={isComponentDisabled(objMod, props.disabled) || false}
		>
			{props.text || i18next.t("upload")}
			<input type="file" hidden onChange={handleFileChange} {...attr} />
		</Button>
	) : null;
}
